<template>
	<a-card :bordered="false" class="dashboard-bar-line header-solid">
		<template #title>
			<h6 class="head-item">行程订单成交量
				<a-range-picker style="width: 240px;" :allowClear="false" :disabled-date="disabledDate" size="small"
					:show-time="{
						hideDisabledOptions: true,
						defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
					}" format="YYYY-MM-DD" value-format="YYYY-MM-DD HH:mm:ss" v-model="time" @ok="onChangeTime" />
			</h6>
			<p>统计条件为：单次行程中有审核通过的收款信息<span class="text-success"></span></p>
		</template>
		<template #extra>
			<a-badge color="primary" class="badge-dot-primary" text="制作行程总数量" />
			<a-badge color="primary" class="badge-dot-secondary" text="有效成交" />
		</template>
		<chart-line :height="330" :data="lineChartData"></chart-line>
		<!-- <div class="card-title">
			<h6>其他项目数据</h6>
			<p>Other project data <span class="text-success"></span></p>
		</div> -->
		<!-- <a-row class="card-footer" type="flex" justify="center" align="top">
			<a-col :span="12">
				<h4>{{ todayTotalCountDatas }}</h4>
				<span>今日有效成交</span>
			</a-col>
			<a-col :span="12">
				<h4>772</h4>
				<span>今日复够成交</span>
			</a-col>
		</a-row> -->
	</a-card>

</template>

<script>
import moment from 'moment';
// Bar chart for "Active Users" card.
import ChartLine from '../Charts/ChartLine';

export default ({
	components: {
		ChartLine,
	},
	props: {
		lineChartData: Object,
		todayTotalCountDatas: {
			type: [String, Number],
			default: "0"
		}
	},
	data() {
		return {
			moment,
			time: [
				moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'),
				moment().format('YYYY-MM-DD 23:59:59'),
			],//默认前三天转为 YYYY-MM-DD HH:mm:ss
		}
	},
	methods: {
		disabledDate(current) {
			// Can not select days before today and today
			return current && current > moment().endOf('day');
		},
		onChangeTime(e) {
			console.log(e)
			this.$emit('changedate', e);
		}
	},
	mounted() {
		this.$emit('changedate', this.time);
	},
})

</script>

<style scoped>
.head-item {
	width: 50%;
}

@media screen and (max-width: 768px) {
	.head-item {
		width: 100%;
	}
}
</style>